export default __webpack_public_path__ + "static/media/activate.2eac17ab.png";